import React, {
    ChangeEvent,
    Dispatch,
    FormEvent,
    SetStateAction,
    useState,
} from "react";
import { UserData, useRegisterMutation } from "../../app/services/auth";
import classes from "./LoginForm.module.css";
function RegisterForm() {
    const [user, setUser] = useState<UserData>({
        email: "",
        password: "",
        roles: "",
    });

    const [register] = useRegisterMutation();
    const submitHandle = (e: FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        register(user);
    };
    const inputChangeHandle = (
        e: ChangeEvent,
        state: UserData,
        setState: Dispatch<SetStateAction<UserData>>
    ) => {
        const target = e.target as HTMLInputElement;
        setState({
            ...state,
            [target.name]: target.value,
        });
    };
    return (
        <form onSubmit={submitHandle} className={classes.form_wrap}>
            <input
                className={classes.input}
                type="email"
                placeholder="email"
                name="email"
                onChange={(e) => {
                    inputChangeHandle(e, user, setUser);
                }}
                value={user.email}
            />

            <input
                className={classes.input}
                type="password"
                placeholder="пароль"
                name="password"
                onChange={(e) => {
                    inputChangeHandle(e, user, setUser);
                }}
                value={user.password}
            />

            <button>Зарегистрировтаься</button>
        </form>
    );
}

export default RegisterForm;
